/**
 * Decorate a DatoCMS `seoMetaTags.tags` array for a paginated listing page.
 *
 * The blog landing page holds a single set of SEO tags in the CMS, which would
 * otherwise be cloned verbatim across every paginated and category listing
 * page. This prefixes the category and appends the page position so each page
 * has a distinct title and description.
 *
 * Tags are left structurally untouched - `HeadTags` keys meta tags by
 * `attributes.property || attributes.name`, so those attributes are preserved.
 */
const TITLE_KEYS = ['og:title', 'twitter:title'];
const DESCRIPTION_KEYS = [
    'description',
    'og:description',
    'twitter:description'
];

const metaKey = (attributes) =>
    attributes.property || attributes.name || '';

export default (tags, { categoryName, currentPage, numPages }) => {
    const isPaginated = currentPage > 1;
    if (!isPaginated && !categoryName) {
        return tags;
    }

    const decorateTitle = (text) =>
        [
            categoryName ? `${categoryName} | ` : '',
            text,
            isPaginated ? ` | Page ${currentPage} of ${numPages}` : ''
        ].join('');

    const decorateDescription = (text) =>
        [
            categoryName
                ? `Read the latest ${categoryName} articles from thinkmoney.`
                : text,
            isPaginated ? ` Page ${currentPage} of ${numPages}.` : ''
        ].join('');

    return tags.map((tag) => {
        if (tag.tagName === 'title') {
            return { ...tag, content: decorateTitle(tag.content) };
        }

        if (tag.tagName !== 'meta') {
            return tag;
        }

        const key = metaKey(tag.attributes);
        const decorate = TITLE_KEYS.includes(key)
            ? decorateTitle
            : DESCRIPTION_KEYS.includes(key) && decorateDescription;

        if (!decorate) {
            return tag;
        }

        return {
            ...tag,
            attributes: {
                ...tag.attributes,
                content: decorate(tag.attributes.content)
            }
        };
    });
};
